import {
  realtimeLoading,
  realtimeData,
  isAuthorized,
  hasPropertyId,
} from "../state";
import services from "../../../services";

/**
 * Gerçek zamanlı verileri getir
 * @param {string} assetId - Asset ID
 */
export async function fetchRealtimeData(assetId) {
  realtimeLoading.value = true;

  try {
    const result = await services.analytics.getRealtimeData(assetId);

    // Yetkilendirme durumlarını güncelle
    isAuthorized.value = result.isAuthorized;
    hasPropertyId.value = result.hasPropertyId;

    // Veriyi güncelle
    if (result.processedData) {
      realtimeData.value = result.processedData;
    }
  } catch (error) {
    // Hata sessizce yönetildi
  } finally {
    realtimeLoading.value = false;
  }
}
